import React from 'react';
import moment from 'moment';

import DayWrap from './DayWrap';
import DayCounter from './DayCounter';

import GoogleButton from '../../styled-components/GoogleButton';
import P from '../../styled-components/P';

class CountdownElement extends React.Component {
  render() {
    return (
      <GoogleButton
        href={this.props.googleLogin.url}
        darkOnMobile={this.props.googleLogin.darkOnMobile}
        noMargin={this.props.googleLogin.noMargin}>
        <span>{this.props.smallLogo ? this.props.googleLogin.shortened : this.props.googleLogin.label}</span>
      </GoogleButton>
    )
  }
}

export default CountdownElement;



// WEBPACK FOOTER //
// ./src/components/CountdownElement/index.js